export default __webpack_public_path__ + "static/Difi.io_v3-02-633cf576f53b151e01301895f222859a.jpg";